import {ref} from 'vue'
import {BASE_URL} from "@/composables/url_config";
import {log} from "@/composables/useLog"
import axios from "axios";

const error = ref(null)

export const getMvnoApiMethods = async (token) => {
    log("welcome in getMvnoApiMethods")

    if (!token || token === "") {
        return {error: true, message: "No token provided", mvno_api_methods: []}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_mvno_api_methods_api'
        log("url=" + url)

        const result = await axios.get(url, {headers: headers})
        log("result.data din axios getMvnoApiMethods")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getMvnoApiMethods")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getMvnoApiMethods", mvno_api_methods: []}
    }
}

export const addMvnoApiMethod = async (token, data) => {
    log("welcome in addMvnoApiMethod")
    log("data:")
    log(data)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/add_mvno_api_method_api'
        log("url=" + url)

        const payload = {
            name: data.name,
            description: data.description || null
        }

        const result = await axios.post(url, payload, {headers: headers})
        log("result.data din axios addMvnoApiMethod")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in addMvnoApiMethod")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la addMvnoApiMethod"}
    }
}

export const updateMvnoApiMethod = async (token, data) => {
    log("welcome in updateMvnoApiMethod")
    log("data:")
    log(data)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/update_mvno_api_method_api'
        log("url=" + url)

        const payload = {
            id: data.id,
            name: data.name,
            description: data.description
        }

        const result = await axios.put(url, payload, {headers: headers})
        log("result.data din axios updateMvnoApiMethod")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in updateMvnoApiMethod")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la updateMvnoApiMethod"}
    }
}

export const deleteMvnoApiMethod = async (token, id) => {
    log("welcome in deleteMvnoApiMethod")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/delete_mvno_api_method_api'
        log("url=" + url)

        const result = await axios.delete(url, {headers: headers, data: {id: id}})
        log("result.data din axios deleteMvnoApiMethod")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in deleteMvnoApiMethod")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la deleteMvnoApiMethod"}
    }
}

const useMvnoApiMethodsAPI = () => {
    return {
        error,
        getMvnoApiMethods,
        addMvnoApiMethod,
        updateMvnoApiMethod,
        deleteMvnoApiMethod
    }
}

export default useMvnoApiMethodsAPI
